module.exports = __webpack_public_path__ + "static/media/xiaochengxbg2.d08ae969.png";